import { AutocompleteOption, PossibleAutoCompleteValue } from '~shared/models/AutocompleteOption'

export function getOptionByValue(value: string | number | undefined, options: AutocompleteOption[]): AutocompleteOption | null {
  return value ? (options.find((option) => option.value === value) || null) : null
}

export function getOptionsByValues(
  values: PossibleAutoCompleteValue[] | undefined,
  options: AutocompleteOption[],
): AutocompleteOption[] {
  if (!values) {
    return []
  }

  return options.filter((option) => values.includes(option.value))
}
